import { FeedbackRating } from "../../skjema/feedback/Feedback.types";

const feedback = {
  header: "Hvordan var din opplevelse med å fylle inn dette skjemaet?",
  input: {
    beskrivelse: {
      label: "Kan du si litt om hvorfor? (valgfritt)",
      helpText:
        "Ikke skriv personlig informasjon som navn, fødselsnummer eller kontaktopplysninger, men bruk gjerne konkrete eksempler på utfordringer du har opplevd",
    },
  },
  button: {
    send: "Send tilbakemelding",
  },
  validering: {
    maxLength: "Beskrivelsen kan ikke være lengre enn 250 tegn",
  },
  emoji: {
    "5": "Super!",
    "4": "Bra",
    "3": "Ok",
    "2": "Ikke bra",
    "1": "Dårlig",
  } satisfies Record<FeedbackRating, string>,
  alert: {
    success: {
      header: "Tusen takk for tilbakemeldingen",
      message: "Dine innspill hjelper oss med å gjøre tjenesten bedre!",
    },
    failure: {
      header: "Noe gikk galt",
      message:
        "Vi har dessverre ikke mottatt din tilbakemelding. Forsøk gjerne å sende inn på nytt og takk for at du tok deg tid til å svare!",
    },
  },
};
export default feedback;
